import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export const Login = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
});
